import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderBar from '../components/HeaderBar';
import './SpaceTypeSelector.css';

function SpaceTypeSelector({ user, onLogout }) {
    const navigate = useNavigate();

    return (
        <div className="space-type-selector">
            <HeaderBar user={user} onLogout={onLogout} />

            <div className="sts-container">
                <div className="sts-content">
                    <h1 className="sts-title">What would you like to book?</h1>
                    <p className="sts-subtitle">Choose your booking type to get started</p>

                    <div className="sts-options">
                        <div className="sts-card-wrapper">
                            <button
                                className="sts-card desk-card"
                                onClick={() => navigate('/booking')}
                                style={{
                                    backgroundImage: "url('/data/images/desk.jpg')",
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}
                            >
                            </button>
                            <div className="card-content">
                                <h2 className="card-title">Desk</h2>
                                <p className="card-desc">
                                    Book a hot desk for half-day or full-day
                                </p>
                                <ul className="card-features">
                                    <li>✓ Half-day or full-day booking</li>
                                    <li>✓ Choose your preferred zone</li>
                                    <li>✓ Select monitor type</li>
                                </ul>
                            </div>
                        </div>

                        <div className="sts-card-wrapper">
                            <button
                                className="sts-card room-card"
                                onClick={() => navigate('/meeting-room-booking')}
                                style={{
                                    backgroundImage: "url('/data/images/meeting%20room.jpg')",
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}
                            >
                            </button>
                            <div className="card-content">
                                <h2 className="card-title">Collaboration Pod & Phone Booth</h2>
                                <p className="card-desc">
                                    2 person collaboration spaces
                                </p>
                                <ul className="card-features">
                                    <li>✓ Collaboration Pods (4 available)</li>
                                    <li>✓ Phone Booths (6 available)</li>
                                    <li>✓ Flexible duration (30 min - 8 hours)</li>
                                    <li>✓ Real-time availability</li>
                                </ul>
                            </div>
                        </div>

                        <div className="sts-card-wrapper">
                            <button
                                className="sts-card whatsapp-card"
                                onClick={() => window.open('https://wa.me/628115009000', '_blank')}
                                style={{
                                    backgroundImage: "url('/data/images/WhatsApp.png')",
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}
                            >
                            </button>
                            <div className="card-content">
                                <h2 className="card-title">WhatsApp Booking Assistant</h2>
                                <p className="card-desc">
                                    Try our WhatsApp booking assistant
                                </p>
                                <ul className="card-features">
                                    <li>✓ Auto recognition</li>
                                    <li>✓ Book hot desk</li>
                                    <li>✓ Half-day or full-day booking</li>
                                    <li>✓ Real-time availability</li>
                                    <li>✓ Instant confirmation</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SpaceTypeSelector;
